module.exports = false;



/*****************
 ** WEBPACK FOOTER
 ** /Users/luca/dev/juta/ironex.it/~/core-js/modules/_library.js
 ** module id = 35
 ** module chunks = 0
 **/